// GIS-188: which Firebase project the panel talks to. Before this the production
// config was the only option, so every local run and preview build read and wrote
// prod. Set the REACT_APP_FIREBASE_* values (a .env.local or a CI env) to point a
// build at another project; with none set, the build is the production config
// byte for byte.
//
// All or nothing on purpose: a build with a staging projectId but prod's apiKey
// and appId would half-talk to production, which is the exact failure this exists
// to prevent. So setting any of them requires the core set, and fails loudly.

export const DEFAULT_FIREBASE_CONFIG = Object.freeze({
  apiKey: "AIzaSyBCm-r0WtWEZzstHd_C3zq2grqrY3ssQvA",
  authDomain: "speed-dating-sf.firebaseapp.com",
  databaseURL: "https://speed-dating-sf-default-rtdb.firebaseio.com",
  projectId: "speed-dating-sf",
  storageBucket: "speed-dating-sf.appspot.com",
  messagingSenderId: "319524791655",
  appId: "1:319524791655:web:93537228c9e14afe2b3bc2",
});

export const DEFAULT_FUNCTIONS_REGION = "us-central1";

export const FIREBASE_ENV_KEYS = Object.freeze({
  apiKey: "REACT_APP_FIREBASE_API_KEY",
  authDomain: "REACT_APP_FIREBASE_AUTH_DOMAIN",
  databaseURL: "REACT_APP_FIREBASE_DATABASE_URL",
  projectId: "REACT_APP_FIREBASE_PROJECT_ID",
  storageBucket: "REACT_APP_FIREBASE_STORAGE_BUCKET",
  messagingSenderId: "REACT_APP_FIREBASE_MESSAGING_SENDER_ID",
  appId: "REACT_APP_FIREBASE_APP_ID",
});

// databaseURL is optional: a project without Realtime Database has none.
const REQUIRED_FIELDS = ["apiKey", "authDomain", "projectId", "storageBucket", "messagingSenderId", "appId"];

const clean = (value) => (typeof value === "string" ? value.trim() : "");

export function buildFirebaseConfig(env = process.env) {
  const given = {};
  for (const [field, key] of Object.entries(FIREBASE_ENV_KEYS)) {
    const value = clean(env[key]);
    if (value) given[field] = value;
  }
  if (Object.keys(given).length === 0) return { ...DEFAULT_FIREBASE_CONFIG };

  const missing = REQUIRED_FIELDS.filter((field) => !given[field]);
  if (missing.length > 0) {
    throw new Error(
      `Incomplete Firebase config: also set ${missing.map((f) => FIREBASE_ENV_KEYS[f]).join(", ")}, ` +
      "or unset every REACT_APP_FIREBASE_* value to build against production."
    );
  }
  return given;
}

export function buildFunctionsRegion(env = process.env) {
  return clean(env.REACT_APP_FIREBASE_FUNCTIONS_REGION) || DEFAULT_FUNCTIONS_REGION;
}

export const firebaseConfig = buildFirebaseConfig();
export const FUNCTIONS_REGION = buildFunctionsRegion();

/** Public URL of an HTTP function in the configured project. */
export function functionUrl(functionName, region = FUNCTIONS_REGION, projectId = firebaseConfig.projectId) {
  return `https://${region}-${projectId}.cloudfunctions.net/${functionName}`;
}
